// extracted by mini-css-extract-plugin
export default {"VisibilityContainer":"SettingsHeadingVisibility_VisibilityContainer__YKOk8"};